import { AppliedFilter } from './types';

/**
 * Serializa filtros aplicados para query params no formato `filter[campo][operador]`.
 * Convenção compartilhada pelas APIs de settlement, billing e contracts-management.
 */
export const serializeFilters = (filters: AppliedFilter[]): URLSearchParams => {
    const params = new URLSearchParams();

    for (const f of filters) {
        if (f.type === 'boolean') {
            if (f.operator === 'is_true') params.set(`filter[${f.key}]`, 'true');
            else if (f.operator === 'is_false') params.set(`filter[${f.key}]`, 'false');
            continue;
        }

        if (!f.value || (Array.isArray(f.value) && f.value.every((v: any) => !v))) continue;

        switch (f.operator) {
            case 'eq':
            case 'contains':
            case 'starts_with':
            case 'ends_with':
                params.set(`filter[${f.key}][${f.operator}]`, f.value);
                break;
            case 'gt': case 'lt': case 'gte': case 'lte':
            case 'before': case 'after':
                params.set(`filter[${f.key}][${f.operator}]`, f.value);
                break;
            case 'between':
            case 'between_dates':
                if (f.value[0]) params.set(`filter[${f.key}][gte]`, f.value[0]);
                if (f.value[1]) params.set(`filter[${f.key}][lte]`, f.value[1]);
                break;
            case 'in':
            case 'in_lookup': {
                const vals = Array.isArray(f.value) ? f.value.join(',') : f.value;
                if (vals) params.set(`filter[${f.key}]`, vals);
                break;
            }
            case 'not_in': {
                const nvals = Array.isArray(f.value) ? f.value.join(',') : f.value;
                if (nvals) params.set(`filter[${f.key}][not_in]`, nvals);
                break;
            }
        }
    }

    return params;
};

/** Resumo legível de um filtro aplicado — usado no cabeçalho quando colapsado. */
export const describeFilter = (filter: AppliedFilter, operatorLabel: string): string => {
    const value = Array.isArray(filter.value)
        ? filter.value.filter(Boolean).join(' — ')
        : filter.value;
    if (filter.type === 'boolean') return `${filter.label}: ${operatorLabel}`;
    return `${filter.label} ${operatorLabel} ${value}`;
};
